export enum ENUM_PERIOD {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTES = 'MINUTES',
}
